import React, { useEffect, useState } from 'react'
import styles from './kyc.module.scss'
import Button from '../../../../components/Button/Button'
import LinearProgressBar from '../../../../components/ProgressBar/LinearProgressBar';
import useMultipleFileUploadAws from '../../../../hooks/AWSFileUpload/useMultipleFileUploadAws';
import uploadAnimation from '../../../../assets/gif/uploadAnimation.gif';


function IdVerification({ formData, setFormData, setActiveNav, handleInputChange }) {
    const countryList = [
        "India", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola",
        "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria",
        "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
        "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
        "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
        "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
        "Cameroon", "Canada", "Central African Republic", "Chad", "Chile",
        "China", "Colombia", "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica",
        "Croatia", "Cuba", "Cyprus", "Czechia (Czech Republic)", "Denmark",
        "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
        "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini (Swaziland)",
        "Ethiopia", "Fiji", "Finland", "France", "Gabon",
        "Gambia", "Georgia", "Germany", "Ghana", "Greece",
        "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
        "Haiti", "Holy See", "Honduras", "Hungary", "Iceland",
        "Indonesia", "Iran", "Iraq", "Ireland",
        "Israel", "Italy", "Jamaica", "Japan", "Jordan",
        "Kazakhstan", "Kenya", "Kiribati", "Korea (North)", "Korea (South)",
        "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia",
        "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein",
        "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
        "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
        "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco",
        "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar (Burma)",
        "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
        "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway",
        "Oman", "Pakistan", "Palau", "Palestine State", "Panama",
        "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland",
        "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
        "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
        "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles",
        "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
        "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka",
        "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
        "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo",
        "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
        "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
        "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",
        "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    const [uploadPreview, setUploadPreview] = useState(uploadAnimation);
    const {
        uploadErrors,
        uploadFileToS3,
        cancelUpload,
        mediaUrls,
        uploadProgresses,
        estimatedTimes,
    } = useMultipleFileUploadAws();
    const documentType = [
        {
            id: 1,
            label: 'Aadhaar Card',
        },
        {
            id: 2,
            label: 'Driving Licence',
        },
        {
            id: 3,
            label: 'Passport'
        }
    ]

    const handleUpload = async () => {
        console.log('FormData: ', formData);

        if (formData.documentImg) {
            await uploadFileToS3(formData.documentImg);
        }
    }


    useEffect(() => {
        if (mediaUrls && formData?.documentImg?.name && mediaUrls[formData.documentImg.name]) {
            setFormData((prevData) => ({
                ...prevData,
                documentUrl: mediaUrls[formData.documentImg.name],
            }));
            setUploadPreview(formData.documentUrl);
        }
    }, [mediaUrls, formData.documentImg, formData.documentUrl]);

    const handleFormSubmission = () => {
        if (formData.documentCountry && formData.documentType && formData.documentUrl) {
            console.log('Form Data :', formData);
            setActiveNav(3)
        }
        else {
            console.log('Incomplete Form Data :', formData);

            console.log('Please Fill all the details!');
        }
    }
    return (
        <form action="">
            <div className={styles.inputField}>
                <label htmlFor="documentType">Select document type</label>
                <select name="documentType" id="documentType" onChange={handleInputChange} value={formData.documentType}>
                    <option value="">Select</option>
                    {documentType.map((doc) =>
                        <option value={doc.label}>{doc.label}</option>
                    )}
                </select>
            </div>
            <div className={styles.inputField}>

                <label htmlFor="documentCountry">Select document Issue Country</label>
                <select name="documentCountry" id="documentCountry" onChange={handleInputChange} value={formData.documentCountry} required>
                    <option value="">Select</option>
                    {countryList.map((doc) =>
                        <option value={doc}>{doc}</option>
                    )}
                </select>
            </div>

            <div className={styles.inputField}>
                <label htmlFor="documentNumber">Document Number</label>
                <input name='documentNumber' id='documentNumber' type="number" onChange={handleInputChange} value={formData.documentNumber} required />
            </div>

            <div className={styles.uploadField}>
                <div className={styles.inputField}>
                    <label htmlFor="">Upload your document (Image Only, Max 5MB)</label>
                    <input type="file" accept="image/*" name="documentImg" onChange={handleInputChange} required />
                </div>
                {
                    formData.documentImg &&
                    <div className={styles.uploadPreview}>
                        <div className={styles.file}>
                            <div className={styles.media}>
                                {
                                    mediaUrls[formData?.documentImg?.name] ?
                                        <img src={mediaUrls[formData?.documentImg?.name]} alt='' /> :
                                        <img src={uploadPreview} alt="" />
                                }
                            </div>
                            <div className={styles.fileDetails}>
                                <h4>{formData.documentImg.name}</h4>
                                <p>{(formData.documentImg.size / (1024 * 1024)).toFixed(3)} MB</p>
                                <LinearProgressBar progress={uploadProgresses[formData?.documentImg?.name]} height='0.5rem' />
                            </div>
                        </div>
                        <div className={styles.uploadBtnContainer}>
                            <button onClick={handleUpload} type='button' >Upload</button>
                        </div>
                    </div>
                }
            </div>

            <div className={styles.btnContainer}>
                <Button label={'Back'} handleClick={() => setActiveNav(1)} />
                <Button label={'Next'} handleClick={handleFormSubmission} />
            </div>
        </form>
    )
}

export default IdVerification;